export class ReviewAggregationForTagResponse {
  count!: {
    total: number;
    perRating: {
      1: string;
      2: string;
      3: string;
      4: string;
      5: string;
    };
  };
  average!: number;
}
